<template>
  <RightInfoPanelGeneric
    :value="value"
    :title-key="'common.parcels'"
    :items="items"
    :saving="saving"
    @save="$emit('save')"
    @back="$emit('goto-list')"
  >
  </RightInfoPanelGeneric>
</template>

<script>
import RightInfoPanelGeneric from "@/components/Common/RightInfoPanelGeneric.vue";

export default {
  name: "ParcelRightPanel",
  components: {
    RightInfoPanelGeneric,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    items() {
      return [
        {
          labelKey: "common.unit",
          path: "department.name",
          required: true,
        },
        {
          labelKey: "common.name",
          path: "name",
          required: true,
        },
        {
          labelKey: "season",
          path: "season.name",
          required: true,
        },
        {
          labelKey: "common.surface_ha",
          path: "surface",
          required: true,
        },
        {
          labelKey: "common.culture",
          path: "culture.name",
          required: false,
        },
        {
          labelKey: "common.variety",
          path: "variety.name",
          required: false,
        },
      ];
    },
  },
};
</script>
